import { render, staticRenderFns } from "./cico.vue?vue&type=template&id=45c2fd50&"
import script from "./cico.vue?vue&type=script&lang=js&"
export * from "./cico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports